// extracted by mini-css-extract-plugin
module.exports = {"paginationWrap":"iNgLV","selected":"Qgof9","arrowBtn":"VfnNM","disabled":"j4G9k","prevButton":"h4boU","nextButton":"OC2hh"};